import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { fetch_all_containers } from "../../endpoints/API";

export const fetchContainers = async (setContainers, baseUrl, prodTestUrl) => {
  try {
    const response = await fetch_all_containers();
    if (response.statusText=="OK") {
      const data = response?.data
      setContainers(data);
    } else {
      message.error("Failed to fetch container details.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching container details.");
  }
};
